angular.module('EdxStudentReportModule')
  .directive('edxStudentStatsPane', function() {
    return {
      restrict: 'E',
      scope: {
        edxDisplayAverages: '=',
        edxStandardsNames: '=',
        edxStudentData: '=',
        edxViewMode: '='
      },
      templateUrl: '/resources/components/report/student/student-stats-pane/edx-student-stats-pane.directive.html',
      controller: [
        '$filter',
        '$scope',
        'dblUsageStatus',
        function(
          $filter,
          $scope,
          dblUsageStatus) {

          var buildStandardsHtml = function(standardsNames) {
            if (standardsNames) {
              return standardsNames.join('<br>');
            }
          };

          $scope.getCompletedStandardsHtml = function() {
            if ($scope.edxStandardsNames) {
              return buildStandardsHtml($scope.edxStandardsNames.completed);
            }
          };

          $scope.getInProgressStandardsHtml = function() {
            if ($scope.edxStandardsNames) {
              return buildStandardsHtml($scope.edxStandardsNames.inProgress);
            }
          };

          $scope.getStatusStyle = function(status) {
            return "text-" + dblUsageStatus.getStatusString(status);
          };

          $scope.getUsageLessonsTitle = function(status) {
            if (status) {
              return dblUsageStatus.getUsageLessonsHoverMessage(status);
            }
            return '';
          };

          $scope.getUsageTimeTitle = function(status) {
            if (status) {
              return dblUsageStatus.getUsageTimeHoverMessage(status);
            }
            return '';
          };

          $scope.$watch('edxStudentData', function(edxStudentData) {
            if (edxStudentData) {
              var usageTime = $filter('minutes')(edxStudentData.usageTime);
              var lessonsCompleted = $filter('number')(edxStudentData.lessonsCompleted);

              if ($scope.edxDisplayAverages) {
                $scope.formattedUsageTime = '(' + usageTime + ' total)';
                $scope.formattedLessonsCompleted = '(' + lessonsCompleted + ' total)';
              } else {
                $scope.formattedUsageTime = usageTime + ' total';
                $scope.formattedLessonsCompleted = lessonsCompleted + ' total';
              }

            }
          });

        }
      ]
    };
  });
